import { useEffect, useState } from "react";
import Select1 from "../../components/select/select1.jsx";
import Select from "react-select";
import { Card, CardBody } from "./../../components/card/card.jsx";
import { getDataUser, kpiGetIndividu, kpiGetTeam, optionSelector } from "../../config/apiSPA.js";
import KpiTeam from "./kpiTeam.jsx";
import { hasRole } from "../../components/js/user.js";

function Kpi() {
  const [instructor, setInstructor] = useState([]);
  const [kpiTeamData, setKpiTeamData] = useState(null);
  const [kpiIndividuData, setKpiIndividuData] = useState(null);
  const [user, setUser] = useState(null);
  const [notRegistered, setNotregistered] = useState(false);

  const changeInstructor = (e) => {
    let id = e.value;
    kpiGetIndividu(id).then((res) => {
      setKpiIndividuData(res);
    });
  };

  useEffect(() => {
    const loadData = async () => {
      try {
        const [userRes, optionRes, kpiTeamRes] = await Promise.all([getDataUser(), optionSelector("/instructor-maco"), kpiGetTeam()]);
        setInstructor(optionRes);
        setKpiTeamData(kpiTeamRes);
        let isNotRegistered = true;

        if (userRes.isInstructor) {
          try {
            const d = await kpiGetIndividu(userRes.instructor.id);
            setKpiIndividuData(d);
            isNotRegistered = false;
          } catch {
            isNotRegistered = true;
          }
        }
        setNotregistered(isNotRegistered);
      } catch (error) {
        console.error(error);
      }
    };

    loadData();
  }, []);

  return (
    <>
      <h1 className="page-header">
        KPI <small>Key Performance Indicator</small>
      </h1>
      <hr className="mb-4" />
      <p>
        A Key Performance Indicator (KPI), also known as an Indikator Kinerja Utama, is a measurable value that indicates how effectively an organization is achieving its primary business goals. Specifically, KPIs help determine the
        strategic, financial, and operational achievements of a company. They serve as qualitative measurements for performance, assessed within specific time boundaries.
      </p>
      <p>
        In This section displays the general KPI values ​​that have been achieved from the accumulation of{" "}
        <a href="#individualKpi" title="Goto Individual KPI section">
          individual
        </a>{" "}
        KPI values
      </p>

      {/* ------------------------------------KPI All-------------------------------------- */}
      <div className="mb-5">
        <Card>
          <CardBody>
            <div className="row">{kpiTeamData ? <KpiTeam dataKpi={kpiTeamData} /> : "No Data"}</div>
          </CardBody>
        </Card>
      </div>

      {/* ------------------------------------End KPI All-------------------------------------- */}

      {/* ------------------------------------KPI Individual-------------------------------------- */}

      <div id="individualKpi">
        <h3>Individual Performance</h3>
        {notRegistered ? (
          <p className="text-danger">Your ID is not registered for this section.</p>
        ) : (
          <>
            <p>This section displays individual performance</p>
            {hasRole("admin") ? (
              <div className="mb-3">
                <Select
                  options={instructor}
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                  classNamePrefix="react-select"
                  onChange={(e) => changeInstructor(e)}
                />
              </div>
            ) : (
              ""
            )}
            <div className="mb-5">
              <Card>
                <CardBody>
                  <div className="row">{kpiIndividuData ? <KpiTeam dataKpi={kpiIndividuData} /> : "No Data"}</div>
                </CardBody>
              </Card>
            </div>
          </>
        )}
      </div>

      {/* ------------------------------------End KPI Individual-------------------------------------- */}
    </>
  );
}

export default Kpi;
